app.controller('OrderHistoryWebEntryController', ['$rootScope', '$scope', '$stateParams', '$state', '$window', function ($rootScope, $scope, $stateParams, $state, $window) {

    const orderID = $stateParams.order_id ? $stateParams.order_id : $rootScope.model.order.current_order._id;
    $scope.order_id = orderID
    $scope.waiting_for_data = true;
    $scope.view_model = {
        confirm_delete: false
    }

    $scope.visible_order = null;

    $rootScope.service.account.requireMinimumData(function () {
        $rootScope.service.order.requestOrder(orderID, function (success, order) {
            $scope.waiting_for_data = false;
            $scope.visible_order = success && $rootScope.service.order_helper.isOrderWeb(order) ? order : null;
        })
    });

    $scope.checkout = function () {

        $rootScope.service.order.setCurrentOrder($scope.visible_order);

        $rootScope.service.staff.requireCurrentOrderCustomer(function () {
            $rootScope.service.tracking.track_event("Checkout", "Sale complete");

            $state.go('myba.order-checkout.review');
        });
    };

    $scope.resumeOrder = function () {
        $rootScope.service.order.setCurrentOrder($scope.visible_order);
        $rootScope.service.staff.requireCurrentOrderCustomer(function () {

            $rootScope.navigation_manager.requireInitialized(function () {
                $rootScope.service.tracking.track_event("Checkout", "Started from saved order");

                const routeOptions = $rootScope.service.order_helper.recentBrowseRoute($scope.visible_order);
                if (routeOptions) {
                    $state.go(routeOptions.route, routeOptions.options);
                    return;
                }
                $state.go('myba.dashboard');
            })
        });

    };

    $scope.deleteOrder = function () {
        $rootScope.service.order.deleteOrder($scope.visible_order, function () {

            if ($scope.visible_order._id === $rootScope.model.order.current_order._id) {
                $rootScope.service.order.startNewOrder();

            }
            $state.go('myba.dashboard');
        });
    }

}]);